(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/draggable-container/assets/javascripts/draggable-container.js') >= 0) return;  svs.modules.push('/components/lb-ui/draggable-container/assets/javascripts/draggable-container.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const clx = svs.components.lbUtils.clx;
const SCROLL_MULTIPLIER = 2;
const DraggableContainer = _ref => {
  let ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    className = _ref.className,
    indexTab = _ref.indexTab,
    _ref$preventClickProp = _ref.preventClickPropagation,
    preventClickPropagation = _ref$preventClickProp === void 0 ? true : _ref$preventClickProp;
  const containerRef = useRef(null);
  const childrenRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    startX = _useState4[0],
    setStartX = _useState4[1];
  const _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollLeft = _useState6[0],
    setScrollLeft = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isScrollable = _useState8[0],
    setIsScrollable = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    canScrollLeft = _useState0[0],
    setCanScrollLeft = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    canScrollRight = _useState10[0],
    setCanScrollRight = _useState10[1];
  useEffect(() => {
    const containerEl = containerRef.current;
    const contentEl = childrenRef.current;
    const checkScrollPosition = () => {
      if (containerRef.current) {
        const canScrollLeft = containerEl.scrollLeft > 0;
        const canScrollRight = containerEl.scrollLeft < containerEl.scrollWidth - containerEl.clientWidth;
        setCanScrollLeft(canScrollLeft);
        setCanScrollRight(canScrollRight);
      }
    };
    const checkScrollable = () => {
      if (containerEl && contentEl) {
        const containerWidth = containerEl.offsetWidth;
        const childrenWidth = contentEl.scrollWidth;
        setIsScrollable(childrenWidth > containerWidth);
        checkScrollPosition();
      }
    };
    checkScrollable();
    window.addEventListener('resize', checkScrollable);
    containerEl.addEventListener('scroll', checkScrollPosition);
    return () => {
      window.removeEventListener('resize', checkScrollable);
      containerEl.removeEventListener('scroll', checkScrollPosition);
    };
  }, []);
  const handleClick = e => {
    if (preventClickPropagation) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  const startDrag = e => {
    e.preventDefault();
    setIsDragging(true);
    setStartX(e.pageX - e.currentTarget.offsetLeft);
    setScrollLeft(e.currentTarget.scrollLeft);
  };
  const stopDrag = () => setIsDragging(false);
  const onDrag = e => {
    if (!isDragging) {
      return;
    }
    e.preventDefault();
    const x = e.pageX - e.currentTarget.offsetLeft;
    const newPositionX = (x - startX) * SCROLL_MULTIPLIER;
    e.currentTarget.scrollLeft = scrollLeft - newPositionX;
  };
  const validatedIndexTab = typeof indexTab === 'number' && !isNaN(indexTab) ? indexTab : 0;
  const dragCursor = isDragging ? 'grabbing' : 'grab';
  const cursor = isScrollable ? dragCursor : 'auto';
  return React.createElement("div", {
    "aria-label": ariaLabel,
    className: clx('pg_draggable_container', {
      'pg_draggable_container--scrollable': isScrollable,
      'pg_draggable_container--can-scroll-left': canScrollLeft,
      'pg_draggable_container--can-scroll-right': canScrollRight
    }, className),
    onClick: handleClick,
    onMouseDown: startDrag,
    onMouseLeave: stopDrag,
    onMouseMove: onDrag,
    onMouseUp: stopDrag,
    ref: containerRef,
    style: {
      cursor
    },
    tabIndex: isScrollable ? validatedIndexTab : -1
  }, React.createElement("div", {
    className: "pg_draggable_container__content",
    ref: childrenRef
  }, children));
};
setGlobal('svs.components.lbUi.DraggableContainer', DraggableContainer);

 })(window);